import {
  ProcessActionTypes,
  FetchWorkflowsRequestAction,
  FetchWorkflowsSuccessAction,
  FetchWorkflowsFailureAction,
  SubmitStepConfigRequestAction,
  SubmitStepConfigSuccessAction,
  SubmitStepConfigFailureAction,
  SubmitFeedbackRequestAction,
  SubmitFeedbackSuccessAction,
  SubmitFeedbackFailureAction,
  DeleteStepRequestAction,
  DeleteStepSuccessAction,
  DeleteStepFailureAction,
  OptimisticUpdateFeedbackAction,
  OptimisticUpdateStepConfigAction,
  OptimisticDeleteStepAction,
  SetSelectedOfficeTypeAction,
  OpenStepDetailModalAction,
  CloseStepDetailModalAction,
  OpenFeedbackModalAction,
  CloseFeedbackModalAction,
  OpenCanvasViewModalAction,
  CloseCanvasViewModalAction,
} from "./types";

import {
  WorkflowCategoryData,
  WorkflowStepData,
  OfficeType,
  SubmitStepPayload,
  SubmitFeedbackPayload,
  DeleteStepPayload,
  FeedbackEntry,
} from "../../types/process";

// Workflow Actions
export const fetchWorkflowsRequest = (): FetchWorkflowsRequestAction => ({
  type: ProcessActionTypes.FETCH_WORKFLOWS_REQUEST,
});

export const fetchWorkflowsSuccess = (
  categories: WorkflowCategoryData[],
): FetchWorkflowsSuccessAction => ({
  type: ProcessActionTypes.FETCH_WORKFLOWS_SUCCESS,
  payload: categories,
});

export const fetchWorkflowsFailure = (
  error: string,
): FetchWorkflowsFailureAction => ({
  type: ProcessActionTypes.FETCH_WORKFLOWS_FAILURE,
  payload: error,
});

export const submitStepConfigRequest = (
  payload: SubmitStepPayload,
): SubmitStepConfigRequestAction => ({
  type: ProcessActionTypes.SUBMIT_STEP_CONFIG_REQUEST,
  payload,
});

export const submitStepConfigSuccess = (
  categories: WorkflowCategoryData[],
): SubmitStepConfigSuccessAction => ({
  type: ProcessActionTypes.SUBMIT_STEP_CONFIG_SUCCESS,
  payload: categories,
});

export const submitStepConfigFailure = (
  error: string,
): SubmitStepConfigFailureAction => ({
  type: ProcessActionTypes.SUBMIT_STEP_CONFIG_FAILURE,
  payload: error,
});

export const submitFeedbackRequest = (
  payload: SubmitFeedbackPayload,
): SubmitFeedbackRequestAction => ({
  type: ProcessActionTypes.SUBMIT_FEEDBACK_REQUEST,
  payload,
});

export const submitFeedbackSuccess = (
  categories: WorkflowCategoryData[],
): SubmitFeedbackSuccessAction => ({
  type: ProcessActionTypes.SUBMIT_FEEDBACK_SUCCESS,
  payload: categories,
});

export const submitFeedbackFailure = (
  error: string,
): SubmitFeedbackFailureAction => ({
  type: ProcessActionTypes.SUBMIT_FEEDBACK_FAILURE,
  payload: error,
});

export const deleteStepRequest = (
  payload: DeleteStepPayload,
): DeleteStepRequestAction => ({
  type: ProcessActionTypes.DELETE_STEP_REQUEST,
  payload,
});

export const deleteStepSuccess = (
  categories: WorkflowCategoryData[],
): DeleteStepSuccessAction => ({
  type: ProcessActionTypes.DELETE_STEP_SUCCESS,
  payload: categories,
});

export const deleteStepFailure = (error: string): DeleteStepFailureAction => ({
  type: ProcessActionTypes.DELETE_STEP_FAILURE,
  payload: error,
});

// Optimistic Update Actions
export const optimisticUpdateFeedback = (
  targetType: "category" | "step",
  targetId: string,
  feedbackEntry: FeedbackEntry,
): OptimisticUpdateFeedbackAction => ({
  type: ProcessActionTypes.OPTIMISTIC_UPDATE_FEEDBACK,
  payload: { targetType, targetId, feedbackEntry },
});

export const optimisticUpdateStepConfig = (
  payload: SubmitStepPayload,
): OptimisticUpdateStepConfigAction => ({
  type: ProcessActionTypes.OPTIMISTIC_UPDATE_STEP_CONFIG,
  payload,
});

export const optimisticDeleteStep = (
  payload: DeleteStepPayload,
): OptimisticDeleteStepAction => ({
  type: ProcessActionTypes.OPTIMISTIC_DELETE_STEP,
  payload,
});

// UI Actions
export const setSelectedOfficeType = (
  officeType: OfficeType,
): SetSelectedOfficeTypeAction => ({
  type: ProcessActionTypes.SET_SELECTED_OFFICE_TYPE,
  payload: officeType,
});

export const openStepDetailModal = (
  step: WorkflowStepData,
): OpenStepDetailModalAction => ({
  type: ProcessActionTypes.OPEN_STEP_DETAIL_MODAL,
  payload: step,
});

export const closeStepDetailModal = (): CloseStepDetailModalAction => ({
  type: ProcessActionTypes.CLOSE_STEP_DETAIL_MODAL,
});

export const openFeedbackModal = (target: {
  type: "category" | "step";
  id: string;
  name: string;
  feedbackHistory?: FeedbackEntry[];
}): OpenFeedbackModalAction => ({
  type: ProcessActionTypes.OPEN_FEEDBACK_MODAL,
  payload: target,
});

export const closeFeedbackModal = (): CloseFeedbackModalAction => ({
  type: ProcessActionTypes.CLOSE_FEEDBACK_MODAL,
});

export const openCanvasViewModal = (
  category: WorkflowCategoryData,
): OpenCanvasViewModalAction => ({
  type: ProcessActionTypes.OPEN_CANVAS_VIEW_MODAL,
  payload: category,
});

export const closeCanvasViewModal = (): CloseCanvasViewModalAction => ({
  type: ProcessActionTypes.CLOSE_CANVAS_VIEW_MODAL,
});

// Thunk Actions (for use with redux-saga)
export const fetchWorkflows = () => ({
  type: ProcessActionTypes.FETCH_WORKFLOWS_REQUEST,
});

export const submitStepConfig = (payload: SubmitStepPayload) => ({
  type: ProcessActionTypes.SUBMIT_STEP_CONFIG_REQUEST,
  payload,
});

export const submitFeedbackThunk = (payload: SubmitFeedbackPayload) => ({
  type: ProcessActionTypes.SUBMIT_FEEDBACK_REQUEST,
  payload,
});

export const deleteStepThunk = (payload: DeleteStepPayload) => ({
  type: ProcessActionTypes.DELETE_STEP_REQUEST,
  payload,
});
